/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {makeStyles} from '@material-ui/core/styles';
import {translate} from '@ion/core/src/locale/locale';
import {Assets} from '@ion/core/src/types/entities';
import {CellMenuItem} from '@ion/dls/src/grid/CellMenuItem';
import {MapEditIcon} from '@ion/dls/src/icons/MapEditIcon';
import {MoveEntityIcon} from '@ion/dls/src/icons/MoveEntityIcon';
import {dlsColor, dlsTypography} from '@ion/dls/src/theme/theme';
import {moveAdminAssets, showBulkEditGroupDialog} from './state';

// defines the selections header styles ...
export const useStyles = makeStyles(theme => ({
  selectionsLabel : {
    ...dlsTypography('selectionsLabel')
  }
}));

// defines the asset action menu prop definitions ...
export interface AssetsActionMenuTypes {
  selectedAssets: Assets;
  areTotalRowsSelected?: boolean;
  disableAction?: boolean;
}

/**
 * Defines the AssetsActionMenu component. This component contains
 * the row actions for Asset grid.
 */
export const AssetsActionMenu = ({
  selectedAssets,
  areTotalRowsSelected,
  disableAction = false
}: AssetsActionMenuTypes) => {
  const dispatch = useDispatch();
  const color    = dlsColor('white');
  const classes  = useStyles();

  const onBulkEditGroup = useCallback(() => {
    dispatch(showBulkEditGroupDialog(selectedAssets));
  }, [selectedAssets]);

  const onMove = useCallback(() => {
    dispatch(moveAdminAssets(selectedAssets, true));
  }, [selectedAssets]);

  return (
    <>
      <CellMenuItem customStyles={{root: classes.selectionsLabel}}
        icon={<MapEditIcon color={color} />}
        onClick={onBulkEditGroup}
        disabled={disableAction}
        label={translate('grids:selectionsHeader.bulkEditGroup')} />
      <CellMenuItem customStyles={{root: classes.selectionsLabel}}
        icon={<MoveEntityIcon color={color} />}
        onClick={onMove}
        disabled={areTotalRowsSelected || disableAction}
        label={translate('admin-assets:menu.move')} />
    </>
  );
};
export default AssetsActionMenu;
